export enum AppliedLessonType {
    'AppliedLesson' = 'AppliedLesson',
    'PMAppliedLesson' = 'PMAppliedLesson',
    'XAppliedLesson' = 'XAppliedLesson',
}
